import PropTypes from 'prop-types';
import InputComponent from 'components/common/InputComponent';

const LabeledInputComponent = ({ label, name, type, onChange, missingFields = null, ...rest }) => {
  const inputId = rest?.id || name;
  const isMissing = missingFields?.includes?.(name) || missingFields?.has?.(name);

  return (
    <div>
      <label htmlFor={inputId} className="block text-sm font-medium text-gray-700">
        {label}
        {rest.required && ' *'}
      </label>
      <InputComponent
        id={inputId}
        name={name}
        type={type}
        onChange={onChange}
        className={isMissing ? 'border-orange-500' : ''}
        {...rest}
      />
    </div>
  );
};

LabeledInputComponent.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  missingFields: PropTypes.instanceOf(Set),
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool
};

LabeledInputComponent.defaultProps = {
  required: false,
  missingFields: new Set(),
  placeholder: '',
  disabled: false
};

export default LabeledInputComponent;
